/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_Existing_LabelInputs */

const cs_sreality_seller_existing_label = /** @type {(inputs: Sreality_Seller_Existing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Existující makléř na Sreality`)
};

const en_sreality_seller_existing_label = /** @type {(inputs: Sreality_Seller_Existing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Existing Sreality seller`)
};

/**
* | output |
* | --- |
* | "Existing Sreality seller" |
*
* @param {Sreality_Seller_Existing_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_existing_label = /** @type {((inputs?: Sreality_Seller_Existing_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_Existing_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_existing_label(inputs)
	return cs_sreality_seller_existing_label(inputs)
});